import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { SpaceTabDocumentType } from 'api/space/space-tab';
import { setupSpaceTabsOnSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { addDocumentFromTemplateAction } from '../actions';
function* addDocumentFromTemplateSaga(action) {
    const { payload: { spaceId, template, handleAlways, handleFailure, handleSuccess } } = action;
    try {
        const spaceTabId = floatUid();
        yield put(setupSpaceTabsOnSpaces({
            spaceTab: {
                spaceTabId,
                spaceTabTitle: template.templateName || '',
                spaceTabType: SpaceTabDocumentType.RocketlaneDocument,
                url: `/templates/${template.templateId}`
            },
            spaceId
        }));
        if (handleSuccess) {
            handleSuccess(spaceTabId);
        }
    } catch (error) {
        logger.error('an error adding a document template', {
            error
        });
        message.error('There was an error adding a document template');
        if (handleFailure) {
            handleFailure();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export function* watchAddDocumentFromTemplateSaga() {
    yield takeLatest(addDocumentFromTemplateAction.type, addDocumentFromTemplateSaga);
}
